<script setup lang="ts">
    import { ChevronRight } from 'lucide-vue-next';
    import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
    import { Voucher } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { useVoucherStore } from '@/stores/voucher';

    const { t } = useI18n();

    const voucherStore = useVoucherStore();

    const props = defineProps<{
        selectedVouchers: Voucher[];
    }>();

    const assignVouchers = () => {
        voucherStore.setValidVouchers(props.selectedVouchers);
        voucherStore.toggleOpen('project', true);
    };
</script>

<template>
    <DropdownMenuItem @click="assignVouchers">
        {{ t('vouchers.select.assign_project') }}
        <ChevronRight class="text-primary" />
    </DropdownMenuItem>
</template>
